module.exports = __webpack_public_path__ + "img/view-qr.8e9a82e5.svg";